export const askVaMigrations = [
  // v0 -> v1
  ({ formData, metadata }) => {
    /**
     * Maps old page paths to new page paths to maintain consistent page order across flows.
     * Pages that moved later in their flows (`oldIndex < newIndex`) return `null`, since
     * passing the actual new index would skip the questions in between that the user never answered.
     *
     * `null` is an invalid `returnUrl`, so Platform's `checkValidPagePath` falls
     * back to the first non-intro page, effectively restarting the flow.
     */
    const consistentPageOrderMap = {
      '/about-myself-relationship-veteran-1': null,
      '/about-myself-relationship-veteran-2':
        '/about-myself-relationship-veteran-1',
      '/about-myself-relationship-veteran-3':
        '/about-myself-relationship-veteran-2',
      '/about-myself-relationship-veteran-4':
        '/about-myself-relationship-veteran-3',
      '/about-myself-relationship-veteran-5':
        '/about-myself-relationship-veteran-4',
      '/about-myself-relationship-veteran-6':
        '/about-myself-relationship-veteran-5',
      '/about-myself-relationship-veteran-7':
        '/about-myself-relationship-veteran-6',
      '/about-myself-relationship-veteran-8':
        '/about-myself-relationship-veteran-7',
      '/about-myself-relationship-veteran-9':
        '/about-myself-relationship-veteran-8',
      '/about-myself-relationship-veteran-10':
        '/about-myself-relationship-veteran-9',
      '/about-someone-else-relationship-family-member-about-family-member-14':
        '/about-someone-else-relationship-family-member-about-family-member-2',
      '/about-someone-else-relationship-family-member-about-family-member-15':
        '/about-someone-else-relationship-family-member-about-family-member-3',
      '/about-someone-else-relationship-family-member-about-family-member-2':
        null,
      '/about-someone-else-relationship-family-member-about-family-member-3':
        null,
      '/about-someone-else-relationship-family-member-about-family-member-4':
        null,
      '/about-someone-else-relationship-family-member-about-family-member-5':
        null,
      '/about-someone-else-relationship-family-member-about-family-member-6':
        null,
      '/about-someone-else-relationship-family-member-about-family-member-7':
        null,
      '/about-someone-else-relationship-family-member-about-family-member-8':
        null,
      '/about-someone-else-relationship-family-member-about-family-member-9':
        null,
      '/about-someone-else-relationship-family-member-about-family-member-10':
        null,
      '/about-someone-else-relationship-family-member-about-family-member-11':
        null,
      '/about-someone-else-relationship-family-member-about-family-member-12':
        null,
      '/about-someone-else-relationship-family-member-about-family-member-13':
        null,
      '/about-myself-relationship-family-member-4': null,
      '/about-myself-relationship-family-member-5':
        '/about-myself-relationship-family-member-4',
      '/about-myself-relationship-family-member-6':
        '/about-myself-relationship-family-member-5',
      '/about-myself-relationship-family-member-7':
        '/about-myself-relationship-family-member-6',
      '/about-myself-relationship-family-member-8':
        '/about-myself-relationship-family-member-7',
      '/about-myself-relationship-family-member-9':
        '/about-myself-relationship-family-member-8',
      '/about-myself-relationship-family-member-10':
        '/about-myself-relationship-family-member-9',
      '/about-myself-relationship-family-member-11':
        '/about-myself-relationship-family-member-10',
      '/about-myself-relationship-family-member-12':
        '/about-myself-relationship-family-member-11',
      '/about-myself-relationship-family-member-13':
        '/about-myself-relationship-family-member-12',
      '/general-question-1': null,
      '/general-question-2': '/general-question-1',
      '/general-question-3': '/general-question-2',
      '/general-question-4': '/general-question-3',
      '/general-question-5': '/general-question-4',
      '/general-question-6': '/general-question-5',
      '/general-question-7': '/general-question-6',
      '/general-question-8': '/general-question-7',
      '/general-question-9': '/general-question-8',
      '/general-question-10': '/general-question-9',
    };

    return {
      formData,
      metadata: {
        ...metadata,
        returnUrl:
          metadata?.returnUrl in consistentPageOrderMap
            ? consistentPageOrderMap[metadata.returnUrl]
            : metadata?.returnUrl,
      },
    };
  },
  // v1 -> v2
  ({ formData, metadata }) => {
    const renamedPages = {
      '/category-topic-1': '/select-category',
      '/category-topic-2': '/select-topic',
      '/category-topic-3': '/select-subtopic',
    };

    return {
      formData,
      metadata: {
        ...metadata,
        returnUrl: renamedPages[metadata?.returnUrl] ?? metadata?.returnUrl,
      },
    };
  },
];
